import moment from 'moment';
import { ReactNode } from 'react';

export const getMonthDateFormat = (dateString: string): ReactNode => {
  const m = moment.utc(dateString);

  const dayWithSuffix = m.format('Do'); // "7th"
  const dayNumber = m.format('D'); // "7"
  const suffix = dayWithSuffix.replace(dayNumber, '');
  return (
    <>
      {m.format('MMMM')} {dayNumber}
      <sup>{suffix}</sup>, {m.format('YYYY')}
    </>
  );
};
